import cc from 'classcat';
import { useRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useStrokeWidth } from './hooks/useStrokeWidth.js';
import { svgCls } from './styles/svg.js';

const PATH = "M0 0h512v512H0z";
const RectangleOutlinedShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  const internalRef = useRef(null);
  const ref = shapeRef ?? internalRef;

  // double stroke width and use clip-path to mimic an inside stroke, which is
  // what we're technically aiming for
  const strokeWidth = 2 * useStrokeWidth(ref, 15, {
    width: 400,
    height: 400
  });
  return /*#__PURE__*/jsxs("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    stroke: fillColor,
    children: [/*#__PURE__*/jsx("clipPath", {
      id: "RectangleOutlinedClipPath",
      children: /*#__PURE__*/jsx("path", {
        d: PATH
      })
    }), /*#__PURE__*/jsx("path", {
      d: PATH,
      fill: "none",
      clipPath: "url(#RectangleOutlinedClipPath)",
      vectorEffect: "non-scaling-stroke",
      strokeWidth: strokeWidth
    })]
  });
};

export { RectangleOutlinedShape };
//# sourceMappingURL=RectangleOutlinedShape.js.map
